import UI from 'root/ui';
import Cache from 'root/cache';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'view/base';
import Util from 'root/module/util';

export default View.extend({
    avatar: {
        name: '',
        type: '',
        content: '',
    },

    events: {
        'input input[name="display_name"]': 'checkChange',
        'input input[name="email"]'       : 'checkChange',
        'submit .user-form'               : 'submit',
        'click .password-change'          : 'passwordChange',
        'click .profile-delete'           : 'onDelete',
        'click .confirm-email'            : 'confirmEmail',
        'click .user-image-upload'        : 'onSelectProfilePic',
        'click .user-image-remove'        : 'onRemoveProfilePic',
    },

    dom_handlers: {
        checkChange: function() {
            this.checkChange();
        },

        confirmEmail: function(e) {
            e.preventDefault();
            Modals.sendEmailConfirmation();
        },

        onSelectProfilePic: function(e) {
            e.stopPropagation();

            Util.uploadImages(1, 2, (response) => {
                if (response[0].error) {
                    UI.error(response[0].error);
                } else if (response[0].content) {
                    this.avatar = {
                        name    : response[0].name,
                        type    : response[0].type,
                        content : response[0].content
                    };

                    this.$el.find('.user-profile-avatar img ').attr('src', this.avatar.content);
                    this.$el.find('.user-image-remove').show();
                    this.checkChange();
                }
            });
        },

        onRemoveProfilePic: function(e) {
            e.stopPropagation();

            if (this.model.get('avatar')) {
                this.avatar = {
                    name: 'delete',
                    type: 'delete',
                    content: 'delete',
                }
            } else {
                this.avatar = {
                    name: '',
                    type: '',
                    content: '',
                }
            }

            this.$el.find('.user-profile-avatar img').attr('src', Util.gravatar(this.model.get('email'), 64, this.model.get('name')));
            this.$el.find('.user-image-remove').hide();
            this.checkChange();
        },

        submit: function(e) {
            var data = Form.getData(this.$el.find('.user-form'));
            var email_changed = data.email !== this.model.get('email');

            this.$el.find('button:submit').addClass('loading').prop('disabled', true);

            this.saveAvatar();

            Cache.app.request({
                action:  'portal_user/update',
                data:    data,
                context: this,
                success: function(response) {
                    if (response.error_msg) {
                        this.$el.find('.banner-danger').text(response.error_msg).show();
                    } else {
                        this.model.set({
                            email        : data.email,
                            display_name : data.display_name
                        });

                        if (email_changed && this.model.get('is_email_confirmed')) {
                            this.model.set('is_email_confirmed', false);
                            this.render();
                        } else {
                            this.on_success();
                        }

                        UI.success('Profile details updated');
                    }
                },
                complete: function() {
                    this.$el.find('button:submit').removeClass('loading').prop('disabled', false);
                }
            });
        },

        passwordChange: function(e) {
            e.preventDefault();
            Modals.changePassword(this.model.id, true);
        },

        onDelete: function() {
            Modals.deletePortalProfile();
        }
    },

    checkChange: function() {
        var is_changed = false;

        var data = Form.getData(this.$el.find('.user-form'));

        if (data.display_name !== this.model.get('display_name')) {
            is_changed = true;
        } else if (data.email !== this.model.get('email')) {
            is_changed = true;
        } else if (this.avatar.content !== this.model.get('avatar')) {
            is_changed = true;
        }

        this.$el.find('button:submit').prop('disabled', !is_changed);
    },

    saveAvatar: function(e) {
        if (!this.avatar.name) {
            return;
        }

        if (Cache.real_user_id) {
            Cache.app.request({
                action: 'user/updateAvatar',
                data: this.avatar,
                success: (response) => {
                    if (this.avatar.name === 'remove') {
                        this.model.set('avatar', '');
                    } else {
                        this.model.set('avatar', response.avatar_url);
                    }
                }
            });
        } else if (Cache.portal_user) {
            Cache.app.request({
                action: 'portal_user/updateAvatar',
                data: this.avatar,
                success: (response) => {
                    if (this.avatar.name === 'remove') {
                        this.model.set('avatar', '');
                    } else {
                        this.model.set('avatar', response.avatar_url);
                    }
                }
            });
        }
    },

    initialize: function(options) {
        this.model      = Cache.portal_user;
        this.on_success = options.on_success;
    },

    render: function() {
        var content =
        '<div class="float-left">' +
            '<div class="user-profile-avatar margin-bottom-24">' +
                '<div class="user-image-remove"><i class="fa-solid fa-times"></i></div>' +
                '<div class="photo">' +
                    '<img class="user-64" src="' + this.model.getAvatar(64) + '">' +
                    '<div class="user-image-upload"><i class="fas fa-camera"></i></div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '<form class="user-form form-fluid margin-left-96">' +
            '<div class="banner-danger" style="display:none;"></div>' +
            '<div class="row">' +
                '<div class="field-label">Name</div>' +
                '<input type="text" class="solid medium" name="display_name" maxlength="255" required>' +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">Email</div>' +
                '<input type="email" class="solid medium" name="email" maxlength="255" required>' +

                (this.model.get('is_email_confirmed') ? '' :
                '<div class="margin-top-4"><a class="confirm-email warning text-medium" href="#"><i class="fas fa-exclamation-circle margin-right-4"></i>Confirm my email address</a></div>') +
            '</div>' +
            '<div class="row">' +
                '<div class="field-label">' +
                    'Password' +
                    '<a href="#" class="password-change float-right">Change</a>' +
                '</div>' +
                '<input type="password"  class="solid medium" value="....................">' +
            '</div>' +

            '<div class="divider-4"></div>' +

            '<div class="text-align-right">' +
                '<button type="button" class="profile-delete secondary medium float-left">Delete</button>' +
                '<button type="submit" class="primary" disabled>Save Changes</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        Form.setData(this.$el.find('.user-form'), this.model.attributes);

        if (this.model.get('avatar')) {
            this.avatar.content = this.model.get('avatar');
        } else {
            this.$el.find('.user-image-remove').hide();
        }

        return this;
    }
});